/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useEffect } from "react";
import { useCookieConsent } from "@/src/provider/CookieConsent/CookieConsentProvider";
import * as TagManager from "react-gtm-module";
import GtmConfig from "@/src/services/gtmConfig";

export default function useGoogleTagManager() {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (hasConsent("analytics")) {
      const tagManagerArgs = GtmConfig();
      // @ts-ignore
      TagManager.initialize(tagManagerArgs);
    }
  }, [hasConsent]);
}
